export const SET_INITIAL_CONFIG = 'SET_INITIAL_CONFIG';

export const SET_INITIAL_PARENT_ITEM = 'SET_INITIAL_PARENT_ITEM';

export const SET_CHILDREN_COUNT = 'SET_CHILDREN_COUNT';
export const SET_ITEM_CHILDREN = 'SET_ITEM_CHILDREN';
export const SET_ITEM_CHILDREN_FLAGS = 'SET_ITEM_CHILDREN_FLAGS';
export const SET_EPIC_PAGE_INFO = 'SET_EPIC_PAGE_INFO';
export const SET_ISSUE_PAGE_INFO = 'SET_ISSUE_PAGE_INFO';
export const SET_HEALTH_STATUS = 'SET_HEALTH_STATUS';
export const SET_WEIGHT_SUM = 'SET_WEIGHT_SUM';

export const REQUEST_ITEMS = 'REQUEST_ITEMS';
export const RECEIVE_ITEMS_SUCCESS = 'RECEIVE_ITEMS_SUCCESS';
export const RECEIVE_ITEMS_FAILURE = 'RECEIVE_ITEMS_FAILURE';

export const SET_REMOVE_ITEM_MODAL_PROPS = 'SET_REMOVE_ITEM_MODAL_PROPS';
export const REQUEST_REMOVE_ITEM = 'REQUEST_REMOVE_ITEM';
export const RECEIVE_REMOVE_ITEM_SUCCESS = 'RECEIVE_REMOVE_ITEM_SUCCESS';
export const RECEIVE_REMOVE_ITEM_FAILURE = 'RECEIVE_REMOVE_ITEM_FAILURE';

export const EXPAND_ITEM = 'EXPAND_ITEM';
export const COLLAPSE_ITEM = 'COLLAPSE_ITEM';

export const TOGGLE_ADD_ITEM_FORM = 'TOGGLE_ADD_ITEM_FORM';
export const TOGGLE_CREATE_EPIC_FORM = 'TOGGLE_CREATE_EPIC_FORM';
export const TOGGLE_CREATE_ISSUE_FORM = 'TOGGLE_CREATE_ISSUE_FORM';

export const SET_PENDING_REFERENCES = 'SET_PENDING_REFERENCES';
export const ADD_PENDING_REFERENCES = 'ADD_PENDING_REFERENCES';
export const REMOVE_PENDING_REFERENCE = 'REMOVE_PENDING_REFERENCE';

export const SET_ITEM_INPUT_VALUE = 'SET_ITEM_INPUT_VALUE';

export const REQUEST_ADD_ITEM = 'REQUEST_ADD_ITEM';
export const RECEIVE_ADD_ITEM_SUCCESS = 'RECEIVE_ADD_ITEM_SUCCESS';
export const RECEIVE_ADD_ITEM_FAILURE = 'RECEIVE_ADD_ITEM_FAILURE';

export const REQUEST_CREATE_ITEM = 'REQUEST_CREATE_ITEM';
export const RECEIVE_CREATE_ITEM_SUCCESS = 'RECEIVE_CREATE_ITEM_SUCCESS';
export const RECEIVE_CREATE_ITEM_FAILURE = 'RECEIVE_CREATE_ITEM_FAILURE';

export const REORDER_ITEM = 'REORDER_ITEM';

export const MOVE_ITEM = 'MOVE_ITEM';
export const MOVE_ITEM_FAILURE = 'MOVE_ITEM_FAILURE';

export const SET_PROJECTS = 'SET_PROJECTS';
export const REQUEST_PROJECTS = 'REQUEST_PROJECTS';
export const RECEIVE_PROJECTS_SUCCESS = 'RECEIVE_PROJECTS_SUCCESS';
export const RECEIVE_PROJECTS_FAILURE = 'RECEIVE_PROJECTS_FAILURE';

export const REQUEST_DESCENDANT_GROUPS = 'REQUEST_DESCENDANT_GROUPS';
export const RECEIVE_DESCENDANT_GROUPS_SUCCESS = 'RECEIVE_DESCENDANT_GROUPS_SUCCESS';
export const RECEIVE_DESCENDANT_GROUPS_FAILURE = 'RECEIVE_DESCENDANT_GROUPS_FAILURE';

export const SET_SHOW_LABELS = 'SET_SHOW_LABELS';
export const SET_DEFAULT_PROJECT_FOR_ISSUE_CREATION = 'SET_DEFAULT_PROJECT_FOR_ISSUE_CREATION';
